import React from 'react'

export default function SuccessOrErrorModal({
  submitSuccess,
  submitError,
  setSubmitSuccess,
  setSubmitError,
  setIsSubmitting,
}) {
  if (!submitSuccess && !submitError) return null

  const isSuccess = !!submitSuccess

  return (
    <div
      className='modal-overlay'
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 100000,
      }}
    >
      <div
        className='modal-message-window'
        style={{
          backgroundColor: 'white',
          borderRadius: '16px',
          padding: '40px 32px 32px 32px',
          maxWidth: '420px',
          width: '90%',
          boxShadow:
            '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
          textAlign: 'center',
          position: 'relative',
        }}
      >
        {/* Close X button */}
        <button
          onClick={() => {
            if (isSuccess) {
              setSubmitSuccess(false)
              setIsSubmitting(false)
            }
            if (submitError) {
              setSubmitError(false)
              setIsSubmitting(false)
            }
          }}
          style={{
            position: 'absolute',
            top: 18,
            right: 18,
            background: 'transparent',
            border: 'none',
            fontSize: 22,
            cursor: 'pointer',
            color: '#94A3B8',
          }}
          aria-label='Close message modal'
        >
          &times;
        </button>

        {/* Success/Error Icon */}
        <div
          style={{
            background: isSuccess
              ? 'rgba(59, 130, 246, 0.15)'
              : 'rgba(220, 38, 38, 0.15)',
            width: 70,
            height: 70,
            borderRadius: '50%',
            margin: '0 auto 27px auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {isSuccess ? (
            // Checkmark circle SVG
            <svg width='50' height='50' viewBox='0 0 70 70' fill='none'>
              <circle
                cx='35'
                cy='35'
                r='30'
                stroke='#3B82F6'
                strokeWidth='4'
                fill='none'
              />
              <path
                d='M27 37 L34 44 L47 31'
                stroke='#3B82F6'
                strokeWidth='4'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          ) : (
            // X/Cross error SVG
            <svg width='50' height='50' viewBox='0 0 70 70' fill='none'>
              <circle
                cx='35'
                cy='35'
                r='30'
                stroke='#dc2626'
                strokeWidth='4'
                fill='none'
              />
              <path
                d='M25 25 L45 45 M45 25 L25 45'
                stroke='#dc2626'
                strokeWidth='4'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          )}
        </div>

        <h3
          style={{
            marginBottom: '14px',
            color: isSuccess ? '#059669' : '#dc2626',
            fontWeight: 'bold',
            fontSize: '22px',
          }}
        >
          {isSuccess
            ? 'Request Submitted Successfully!'
            : 'Message Sending Failed'}
        </h3>
        <p
          style={{
            fontSize: '15px',
            color: '#374151',
            marginBottom: '32px',
          }}
        >
          {isSuccess
            ? 'Thank you for reaching out. Our team will review your project requirements and get back to you within 2 business days.'
            : 'Please try again later.'}
        </p>
        <button
          className='contact-button contact-button-primary'
          onClick={() => {
            if (isSuccess) {
              setSubmitSuccess(false)
              setIsSubmitting(false)
            }
            if (submitError) {
              setSubmitError(false)
              setIsSubmitting(false)
            }
          }}
          style={{
            padding: '10px 24px',
            backgroundColor: isSuccess ? '#059669' : '#dc2626',
            border: 'none',
            borderRadius: '8px',
            color: 'white',
            cursor: 'pointer',
            fontWeight: '600',
            fontSize: '16px',
          }}
        >
          Close
        </button>
      </div>
    </div>
  )
}
